export const fastRunOptions = {
  data() {
    return {
      fastRunOptions: [
        {
          label: this.$t("settings.form.fastRunOptions.classic"),
          value: "classic",
          preset: [
            "enteringpayments",
            "enteringsubsidies",
            "subscribers",
            "errorpayments",
            "bankpay",
            "packsreceipts",
            "relationship",
            "assignoperators",
            "controlpacks",
            "controlinetpays",
            // "acceptedshipment",
            "reports"
          ]
        },
        {
          label: this.$t("settings.form.fastRunOptions.basic"),
          value: "basic",
          preset: [
            "bankpay",
            "packsreceipts",
            "relationship",
            "assignoperators",
            "controlpacks",
            "controlinetpays",
            "subscribers",
            "errorpayments",
            "enteringpayments",
            "enteringsubsidies",
            // "acceptedshipment",
            "reports"
          ]
        },
        {
          label: this.$t("settings.form.fastRunOptions.user"),
          value: "user",
          preset: [
            "bankpay",
            "packsreceipts",
            "relationship",
            "enteringpayments",
            "enteringsubsidies",
            "assignoperators",
            "controlpacks",
            "controlinetpays",
            "subscribers",
            "errorpayments",
            // "acceptedshipment",
            "reports"
          ]
        }
      ]
    };
  }
};
